module.exports = __webpack_public_path__ + "static/img/head-bg.5482643.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head-bg.jpg
// module id = vSmd
// module chunks = 1